import * as Types from '../Constants/AllConstants';

// ==================== STANDING REDUCERS ====================

// Get league standings
export const GetLeagueStandingsReducer = (
  state = { standings: [], loading: false },
  action
) => {
  switch (action.type) {
    case Types.STANDING_LEAGUE_LIST_REQUEST:
      return { ...state, loading: true };
    case Types.STANDING_LEAGUE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        standings: action.payload,
      };
    case Types.STANDING_LEAGUE_LIST_FAIL:
      return { loading: false, error: action.payload };
    case Types.STANDING_LEAGUE_LIST_RESET:
      return { standings: [], loading: false };
    default:
      return state;
  }
};

// Get team standings
export const GetTeamStandingsReducer = (
  state = { standings: [], loading: false },
  action
) => {
  switch (action.type) {
    case Types.STANDING_TEAM_LIST_REQUEST:
      return { ...state, loading: true };
    case Types.STANDING_TEAM_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        standings: action.payload,
      };
    case Types.STANDING_TEAM_LIST_FAIL:
      return { loading: false, error: action.payload };
    case Types.STANDING_TEAM_LIST_RESET:
      return { standings: [], loading: false };
    default:
      return state;
  }
};

// Standing details
export const StandingDetailsReducer = (state = { standing: {} }, action) => {
  switch (action.type) {
    case Types.STANDING_DETAILS_REQUEST:
      return { loading: true };
    case Types.STANDING_DETAILS_SUCCESS:
      return { loading: false, standing: action.payload };
    case Types.STANDING_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Create standing
export const CreateStandingReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.STANDING_CREATE_REQUEST:
      return { loading: true };
    case Types.STANDING_CREATE_SUCCESS:
      return { loading: false, success: true, standing: action.payload };
    case Types.STANDING_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.STANDING_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// Update standing
export const UpdateStandingReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.STANDING_UPDATE_REQUEST:
      return { loading: true };
    case Types.STANDING_UPDATE_SUCCESS:
      return { loading: false, success: true, standing: action.payload };
    case Types.STANDING_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.STANDING_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

// Delete standing
export const DeleteStandingReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.STANDING_DELETE_REQUEST:
      return { loading: true };
    case Types.STANDING_DELETE_SUCCESS:
      return { loading: false, success: true };
    case Types.STANDING_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case Types.STANDING_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

// Initialize standings
export const InitializeStandingsReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.STANDING_INITIALIZE_REQUEST:
      return { loading: true };
    case Types.STANDING_INITIALIZE_SUCCESS:
      return { loading: false, success: true };
    case Types.STANDING_INITIALIZE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Recalculate standings
export const RecalculateStandingsReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.STANDING_RECALCULATE_REQUEST:
      return { loading: true };
    case Types.STANDING_RECALCULATE_SUCCESS:
      return { loading: false, success: true };
    case Types.STANDING_RECALCULATE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Get relegation zone
export const GetRelegationZoneReducer = (
  state = { teams: [], loading: false },
  action
) => {
  switch (action.type) {
    case Types.STANDING_RELEGATION_REQUEST:
      return { ...state, loading: true };
    case Types.STANDING_RELEGATION_SUCCESS:
      return { loading: false, teams: action.payload };
    case Types.STANDING_RELEGATION_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Get promotion zone
export const GetPromotionZoneReducer = (
  state = { teams: [], loading: false },
  action
) => {
  switch (action.type) {
    case Types.STANDING_PROMOTION_REQUEST:
      return { ...state, loading: true };
    case Types.STANDING_PROMOTION_SUCCESS:
      return { loading: false, teams: action.payload };
    case Types.STANDING_PROMOTION_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Get top teams
export const GetTopTeamsReducer = (
  state = { teams: [], loading: false },
  action
) => {
  switch (action.type) {
    case Types.STANDING_TOP_TEAMS_REQUEST:
      return { ...state, loading: true };
    case Types.STANDING_TOP_TEAMS_SUCCESS:
      return { loading: false, teams: action.payload };
    case Types.STANDING_TOP_TEAMS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Update standing statuses
export const UpdateStandingStatusesReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.STANDING_UPDATE_STATUSES_REQUEST:
      return { loading: true };
    case Types.STANDING_UPDATE_STATUSES_SUCCESS:
      return { loading: false, success: true };
    case Types.STANDING_UPDATE_STATUSES_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// ==================== TEAM-LEAGUE REDUCERS ====================

// Get league teams
export const GetLeagueTeamsReducer = (
  state = { teams: [], loading: false },
  action
) => {
  switch (action.type) {
    case Types.TEAM_LEAGUE_LIST_REQUEST:
      return { ...state, loading: true };
    case Types.TEAM_LEAGUE_LIST_SUCCESS:
      return { loading: false, teams: action.payload };
    case Types.TEAM_LEAGUE_LIST_FAIL:
      return { loading: false, error: action.payload };
    case Types.TEAM_LEAGUE_LIST_RESET:
      return { teams: [], loading: false };
    default:
      return state;
  }
};

// Get team leagues
export const GetTeamLeaguesReducer = (
  state = { leagues: [], loading: false },
  action
) => {
  switch (action.type) {
    case Types.LEAGUE_TEAM_LIST_REQUEST:
      return { ...state, loading: true };
    case Types.LEAGUE_TEAM_LIST_SUCCESS:
      return { loading: false, leagues: action.payload };
    case Types.LEAGUE_TEAM_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Add team to league
export const AddTeamToLeagueReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.TEAM_LEAGUE_ADD_REQUEST:
      return { loading: true };
    case Types.TEAM_LEAGUE_ADD_SUCCESS:
      return { loading: false, success: true, teamLeague: action.payload };
    case Types.TEAM_LEAGUE_ADD_FAIL:
      return { loading: false, error: action.payload };
    case Types.TEAM_LEAGUE_ADD_RESET:
      return {};
    default:
      return state;
  }
};

// Remove team from league
export const RemoveTeamFromLeagueReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.TEAM_LEAGUE_REMOVE_REQUEST:
      return { loading: true };
    case Types.TEAM_LEAGUE_REMOVE_SUCCESS:
      return { loading: false, success: true };
    case Types.TEAM_LEAGUE_REMOVE_FAIL:
      return { loading: false, error: action.payload };
    case Types.TEAM_LEAGUE_REMOVE_RESET:
      return {};
    default:
      return state;
  }
};

// Get league divisions
export const GetLeagueDivisionsReducer = (
  state = { divisions: [], loading: false },
  action
) => {
  switch (action.type) {
    case Types.LEAGUE_DIVISIONS_REQUEST:
      return { ...state, loading: true };
    case Types.LEAGUE_DIVISIONS_SUCCESS:
      return { loading: false, divisions: action.payload };
    case Types.LEAGUE_DIVISIONS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};